'use strict';

angular.module('app.advertisersManagement', [])
	.controller('advertisersManagementCtrl', ['$scope', '$modal', '$stateParams', 'advertisersManagementService',
		function ($scope, $modal, $stateParams, advertisersManagementService){

		    $scope.preLoaded = false;
		    $scope.currentPage = 1;
		    $scope.pageSize = 10;
		    $scope.currentUrl = null;
		    $scope.company = {
		        id: null,
		        name: null
		    }

		    $scope.preLoadData = function(){    
		        $scope.company.id = $stateParams.id;
		        $scope.company.name = $stateParams.name;
		        var params = {
		            companyId: $scope.company.id,
		            pageNo: $scope.currentPage
		        }
 
		        $scope.sendHttpPOST(params);    
		        $scope.preLoaded = true;
		    };

		    $scope.sendHttpPOST = function(params){
		    	advertisersManagementService.getAdvertisersOfAgency(params, true)
		        	.then(function(responseAdvertiserManagement) {
		        		$scope.advertisers = responseAdvertiserManagement.data;
			            $scope.number = responseAdvertiserManagement.information.totalRow;
			            $scope.agencyName = responseAdvertiserManagement.information.currentCompanyName;
		        		$scope.pagination();
		        	}, function(responseAdvertiserManagement) {
		        		var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = responseAdvertiserManagement.message;
		        	})
		    };

		    if(!$scope.preLoaded){
		        $scope.preLoadData();
		    };

		    $scope.pagination = function(){
		        if($scope.number > 10){
		            if(($scope.number % $scope.pageSize) != 0){
		                var remainNo = $scope.number - ($scope.number % $scope.pageSize) 
		                $scope.pages = remainNo/$scope.pageSize + 1;
		            } else{
		                $scope.pages = $scope.number/$scope.pageSize;
		            }
		        } else{
		            $scope.pages = 1;
		        }    
		    };

		    $scope.updatePage = function(page) {
		        var params = {
		            pageNo: page,
		        }

		        $scope.currentPage = page;
		        $scope.sendHttpPOST(params);   
		    };

		    $scope.deleteAdvertiserFromAgency = function (index) {
		        var deleteAdvertiserFromAgencyModalInstance = $modal.open({
		            scope: $scope,
		            templateUrl: 'app/admin/userAndBilling/userAndBillingOverview/advertisersManagement/deleteAdvertiserFromAgency/deleteAdvertiserFromAgency.html?app_v=deployDate',
		            controller: 'deleteAdvertiserFromAgencyCtrl',
		        });

		        $scope.deleteAdvertiserFromAgencyModalInstance = deleteAdvertiserFromAgencyModalInstance;
		        $scope.company_id = index.id;
		        $scope.company_name = index.name;

		        deleteAdvertiserFromAgencyModalInstance.result.then(function () {
		            $scope.preLoadData();
		        }, function () {
		            
		        });
		    }

		    $scope.addAdvertiserToAgency = function (company_id) {
		        var addAdvertiserToAgencyModalInstance = $modal.open({
		            scope: $scope,
		            templateUrl: 'app/admin/userAndBilling/userAndBillingOverview/advertisersManagement/addAdvertiserToAgency/addAdvertiserToAgency.html?app_v=deployDate',
		            controller: 'addAdvertiserToAgencyCtrl',
		        });

		        $scope.company_id = company_id;
		        $scope.addAdvertiserToAgencyModalInstance = addAdvertiserToAgencyModalInstance;
		    }
    
}])